import React from 'react';
import styled from 'styled-components';
import { Button } from '../styles/components';

const StyledCTAButton = styled(Button)`
  // Add any specific CTA button styling here if needed
`;

const CTAButton = ({ 
  children, 
  onClick, 
  secondary = false, 
  dark = false, 
  ...props 
}) => {
  return (
    <StyledCTAButton
      onClick={onClick}
      $secondary={secondary}
      $dark={dark}
      {...props}
    >
      {children}
    </StyledCTAButton>
  );
};

export default CTAButton; 